import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import { AppComponent } from './app.component';
import {appRoutes} from './app-routes';
import { HttpClientModule } from '@angular/common/http';


import { environment } from '../environments/environment';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {AppSettingsService} from '../services/app-settings.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {RouterModule} from '@angular/router';
import {AuthGuard} from '../services/guards/auth-guard.service';
import {LogoutComponent} from '../Elements/logout/logout.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {FeedBackService} from '../services/feed-back.service';
import {YesNoDialogComponent} from '../Dialogs/yes-no-dialog/yes-no-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ProfileComponent} from './profile/profile.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {AppFooterComponent} from '../Elements/app-footer.component';
import { HomeComponent } from './home/home.component';
import {AppServicesComponent} from '../Elements/app-services.component';
import { TermsComponent } from './terms/terms.component';
import {MatMenuModule} from '@angular/material/menu';
import {MainNavBarModule} from '../Elements/main-nav-bar/main-nav-bar.module';
import {NotFoundModule} from './not-found/not-found.module';
import {HealthFamilyApplicationModule} from './health-family-application/health-family-application.module';
import { MobileApplicationModule } from './mobile-application/mobile-application.module';
import {LoginComponent} from './login/login.component';
import {FormListGeneratorModule} from '../Elements/form-list-generator/form-list-generator.module';
import {CustomButtonModule} from '../Elements/custom-button/custom-button.module';
import {HelpModule} from '../Elements/help/help.module';
import {HelpDialogComponent} from '../Elements/help/help-dialog/help-dialog.component';
import {IndividualAccidentsModule} from './individual-accidents/individual-accidents.module';
import {QuestionsComponent} from './questions/questions.component';
import {FormModule} from '../Elements/form/form.module';
import {ZarinpalComponent} from './zarinpal/zarinpal.component';
import {NormalCalenderComponent} from '../Elements/normal-callender/normal-calender.component';
import {NotesComponent} from './notes/notes.component';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import {IntroductionLetterModule} from './insurance-service/introduction-letter.module';
import {ExternalEmployeeApplicationModule} from './external-employee-application/external-employee-application.module';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {PetApplicationModule} from './pet-application/pet-application.module';
import {HealthGroupApplicationModule} from './health-group-application/health-group-application.module';
import { InvoiceComponent } from './invoice/invoice.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

export let feedback: FeedBackService;
@NgModule({
  declarations: [
    AppComponent,
    LogoutComponent,
    YesNoDialogComponent,
    ProfileComponent,
    AboutUsComponent,
    AppFooterComponent,
    HomeComponent,
    AppServicesComponent,
    TermsComponent,
    LoginComponent,
    QuestionsComponent,
    ZarinpalComponent,
    NormalCalenderComponent,
    NotesComponent,
    MyRequestsComponent,
    InvoiceComponent,
    InvoiceComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      {enableTracing: !environment.production} // <-- debugging purposes only
    ),
    HttpClientModule,
    HealthFamilyApplicationModule,
    ExternalEmployeeApplicationModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MainNavBarModule,
    NotFoundModule,
    MobileApplicationModule,
    FormListGeneratorModule,
    CustomButtonModule,
    IndividualAccidentsModule,
    HelpModule,
    FormModule,
    IntroductionLetterModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    PetApplicationModule,
    HealthGroupApplicationModule,
    MatProgressSpinnerModule
  ],
  providers: [
    AppSettingsService,
    AuthGuard,
    [{provide: LocationStrategy, useClass: HashLocationStrategy}],
    FeedBackService,
    HttpClientWrapperService
  ],
  exports: [
    CustomButtonModule
  ],
  entryComponents: [
    YesNoDialogComponent,
    HelpDialogComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(private feedBack: FeedBackService) {
    feedback = this.feedBack;
  }
}
